import type { DateTimeFormat } from '@intlify/core-base'
import type { I18nOptions } from 'vue-i18n'

const defaultFormats = {
  short: {
    day: 'numeric',
    month: 'short',
  },
  medium: {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  },
  long: {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  },
  full: {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
  },
} satisfies DateTimeFormat

const dateTimeFormats = {
  en: defaultFormats,
  es: defaultFormats,
} satisfies I18nOptions['datetimeFormats']

export default dateTimeFormats
